import axios from "axios";
import { Main } from "components/frame/main";
import React, { Fragment, useState, useEffect } from 'react'
import toast, { Toaster } from "react-hot-toast";
import { useParams } from "react-router-dom";

const FormDetail = () => {
    const [IsLoading, setIsLoading] = useState(false);
    const [SelectedFile, setSelectedFile] = useState();
    const [RadioResponse, setRadioResponse] = useState([]);
    const [CurrentDataResponse, setCurrentDataResponse] = useState(null);
    const [OpenSyarat, setOpenSyarat] = useState(false);
    const [CanInput, setCanInput] = useState(false);
    const [PegawaiResponse, setPegawaiResponse] = useState([]);
    let { id } = useParams();
    console.log('id', id)
    const [Payload, setPayload] = useState({
        id_pegawai: 0,
        id_kategori_layanan_online: 0,
        nama_lengkap: '',
        nip_pegawai: null,
        pangkat_gol: '',
        unit_kerja: '',
        npwp: null,
        no_wa_aktif: null,
        dokumen_layanan: {},
    });

    useEffect(() => {
        if (id != null) {

            setCurrentDataResponse({
                // id: Number(id),
                slug_kategori: id,
                // id_kategori_layanan_online: Number(id),
            })
        }
    }, [id])

    useEffect(() => {
        if (CurrentDataResponse != null) {
            if (CurrentDataResponse.slug_kategori === 'registrasi-sanggar-seni' || CurrentDataResponse.slug_kategori === 'izin-operasional-lembaga' || CurrentDataResponse.slug_kategori === 'izin-operasional-sekolah') {
                setCanInput(true)
            }
            handleGetPegawai()
            handleGetRadio()
        }
    }, [CurrentDataResponse])

    const handleGetRadio = () => {
        setIsLoading(false)
        const axios = require('axios');
        axios.get(process.env.REACT_APP_SERVER_BASE_URL + '/kategori-layanan-online').then(function (res) {
            console.log('res 2', res)
            setRadioResponse(res.data.data)
            console.log('scf')
            let category_id = 0;
            for (let i = 0; i < res.data.data.length; i++) {
                if (CurrentDataResponse.slug_kategori === res.data.data[i].slug_kategori) {
                    category_id = res.data.data[i].id
                }
            }
            console.log('category_id', category_id)
            setPayload((prevObject) => ({ ...prevObject, ...{ id_kategori_layanan_online: Number(category_id) } }))

        }).catch(function (error) {

        }).finally(function () {
            setIsLoading(true)
        })
    };

    const handleGetPegawai = () => {
        const axios = require('axios');
        axios.get(process.env.REACT_APP_SERVER_BASE_URL + '/pegawai').then(function (res) {
            console.log('res pegawai', res)
            setPegawaiResponse(res.data.data)
        }).catch(function (error) {

        }).finally(function () {

        })
    };

    const handlePegawaiSelected = (e) => {
        let foundItem = PegawaiResponse.filter((itemInside, index) => itemInside.id !== Number(e.target.value))
        let pegawai = foundItem[0]

        setPayload((prevObject) => ({
            ...prevObject, ...{
                id_pegawai: pegawai.id,
                nama_lengkap: pegawai.nama_lengkap,
                nip_pegawai: pegawai.nip_pegawai,
                pangkat_gol: pegawai.pangkat,
                unit_kerja: pegawai.unit_kerja,
                npwp: pegawai.npwp,
                no_wa_aktif: pegawai.no_whatsapp,
            }
        }))
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setSelectedFile(file)
        setPayload((prevObject) => ({ ...prevObject, ...{ dokumen_layanan: file } }))
    };

    const createForm = () => {
        const formData = new FormData();
        formData.append('dokumen_layanan', SelectedFile);

        if (Payload.id_pegawai != null && Payload.id_pegawai !== 0) {
            formData.append('id_pegawai', Payload.id_pegawai);
        }
        formData.append('id_kategori_layanan_online', Payload.id_kategori_layanan_online);
        formData.append('nama_lengkap', Payload.nama_lengkap);
        formData.append('nip_pegawai', Payload.nip_pegawai);
        formData.append('pangkat_gol', Payload.pangkat_gol);
        formData.append('unit_kerja', Payload.unit_kerja);
        formData.append('npwp', Payload.npwp);
        if (Payload.dari_tanggal != null) {
            formData.append('dari_tanggal', Payload.dari_tanggal);
        }
        if (Payload.sampai_tanggal != null) {
            formData.append('sampai_tanggal', Payload.sampai_tanggal);
        }
        formData.append('no_wa_aktif', Payload.no_wa_aktif);
        formData.append('dokumen_layanan', Payload.dokumen_layanan);

        const loading = toast.loading('Memproses ....')
        const axios = require('axios');
        axios.post(process.env.REACT_APP_SERVER_BASE_URL + '/store', formData).then(function (res) {
            toast.success('Berhasil Diajukan')
            setTimeout(() => {
                window.location.href = "/informasi/layanan"
            }, 1000);
            // setPegawaiResponse(res.data.data)
        }).catch(function (error) {
            toast.error('Tidak Berhasil Diajukan')
            if (error != null && error.response != null && error.response.data != null && error.response.data.message != null) {
                toast.error(error.response.data.message)
            } else {
                toast.error(error.message)
            }

        }).finally(function () {
            toast.dismiss(loading)
        })
    };

    const checkNip = () => {
        axios.get(process.env.REACT_APP_SERVER_BASE_URL + '/cek-pegawai?nip_pegawai=' + Payload.nip_pegawai).then(function (res) {
            setPayload((prevObject) => ({ ...prevObject, ...{ nama_lengkap: res.data.data.nama_pegawai } }))
            setPayload((prevObject) => ({ ...prevObject, ...{ id_pegawai: res.data.data.id } }))
            setCanInput(true)
            toast.success('NIP Ditemukan')
        }).catch(function (error) {
            toast.error('NIP Tidak Ditemukan')
            setCanInput(false)

        }).finally(function () {

        })
    };

    return (
        <Main>
            {
                CurrentDataResponse != null ?
                    <div className="container mt-10 mb-10">
                        <Toaster />
                        <div className='css-nc0foaw_awf'>

                            <form enctype='multipart/form-data'>
                                {
                                    CurrentDataResponse != null ?
                                        <div className='css-niwqF_an0awf'>
                                            <p className="mb-0">Syarat</p>
                                            {
                                                CurrentDataResponse.slug_kategori === "cuti-melahirkan" ?
                                                    <>
                                                        {/* <h5>CUTI MELAHIRKAN</h5>
                                        <p>1. Surat Permohonan Cuti Dari yang bersangkutan;</p>
                                        <p>2. Surat Keterangan Kelahiran Dokter (Dokter, Bidan, Rumah sakit);</p>
                                        <p>3. Fotokopi SK Awal (CPNS);</p>
                                        <p>4. Fotokopi SK terakhir;</p>
                                        <p>5. Fotokopi SKP terakhir;</p> */}

                                                        <h5>CUTI MELAHIRKAN</h5>
                                                        <p>1.Pengantar Dari Korwil (Untuk GTK)</p>
                                                        <p>2.Pengantar Dari Sekolah (Untuk GTK)</p>
                                                        <p>3.Permohonan Yang Bersangkutan Yang Ditunjukan Kepada Bupati Cq.Kepala Dinas Dikbud </p>
                                                        <p>4.Fotokopi SK awal SK akhir (Legalisir)</p>
                                                        <p>5.Fotokopi KTP (Legalisir)</p>
                                                        <p>6.Fotokopi karpeg (Legalisir)</p>
                                                        <p>7.Fotokopi SKP Tahun Terakhir (Legalisir)</p>
                                                        <p>8.Fotokopi Surat Nikah (Legalisir)</p>
                                                        <p>9.Fotokopi Kartu Keluarga (Legalisir)</p>
                                                        <p>10.Surat Keterangan Dari Dokter / Rumah sakit</p>
                                                    </> : null
                                            }

                                            {
                                                CurrentDataResponse.slug_kategori === "cuti-tahunan" ?
                                                    <>
                                                        <h5>CUTI TAHUNAN</h5>
                                                        <p>1. Permohonan Yang Bersangkutan Yang Ditunjukan Kepada Bupati Cq.Kepala Dinas Dikbud;</p>
                                                        <p>2. Fotokopi SK Awal (CPNS) (Legalisir);</p>
                                                        <p>3. Fotokopi SK terakhir (Legalisir);</p>
                                                        <p>4. Fotokopi SKP 2 tahun terakhir (Legalisir);</p>
                                                        <p>5. Fotokopi KTP (Legalisir)</p>
                                                    </> : null
                                            }

                                            {
                                                CurrentDataResponse.slug_kategori === "cuti-besar" ?
                                                    <>
                                                        {/* <h5>CUTI BESAR</h5>
                                                        <p>1. SURAT PERMOHONAN CUTI DARI YANG BERSANGKUTAN;</p>
                                                        <p>2. PHOTOCOPY KTP, KK, VISA PERJALANAN;</p>
                                                        <p>3. PHOTO COPY SK AWL, SK AKHIR (Legalisir);</p>
                                                        <p>4. SKP TAHUN TERAKHIR;</p>
                                                        <p>5. BUKTI PELUNASAN/KWITANSI;</p>
                                                        <p>6. JADWAL RENCANA KEGIATAN;</p>
                                                        <p>7. SURAT KETERANGAN DARI BIRO/KEMENAG;</p> */}

                                                        <h5>CUTI HAJI</h5>
                                                        <p> 1.Pengantar Dari Korwil (Untuk GTK)</p>
                                                        <p> 2.Pengantar Dari Sekolah (Untuk GTK)</p>
                                                        <p> 3.Permohonan Yang Bersangkutan Yang Ditunjukan Kepada Bupati Cq.Kepala Dinas Dikbud </p>
                                                        <p> 4.Fotokopi SK awal SK akhir (Legalisir)</p>
                                                        <p> 5.Fotokopi KTP (Legalisir)</p>
                                                        <p> 6.Fotokopi karpeg (Legalisir)</p>
                                                        <p> 7.Fotokopi SKP Tahun Terakhir (Legalisir)</p>
                                                        <p> 8.Fotokopi Setoran Lunas Biaya Penyelenggaraan Ibadah Haji(BPIH) </p>
                                                        <p> 9.Fotokopi Jadwal Keberangkatan / Kloter </p>
                                                        <p> 10.Fotokopi Jabatan Akhir (Legalisir)</p>

                                                        <h5 className="mt-3">CUTI UMROH</h5>
                                                        <p> 1.Pengantar Dari Korwil (Untuk GTK)</p>
                                                        <p> 2.Pengantar Dari Sekolah (Untuk GTK)</p>
                                                        <p> 3.Permohonan Yang Bersangkutan Yang Ditunjukan Kepada Bupati Cq.Kepala Dinas Dikbud </p>
                                                        <p> 4.Fotokopi SK awal SK akhir (Legalisir)</p>
                                                        <p> 5.Fotokopi KTP (Legalisir)</p>
                                                        <p> 6.Fotokopi karpeg (Legalisir)</p>
                                                        <p> 7.Fotokopi SKP Tahun Terakhir (Legalisir)</p>
                                                        <p> 8.Fotokopi Setoran Lunas Biaya Penyelenggaraan Umroh </p>
                                                        <p> 9.Fotokopi Jadwal Keberangkatan / Kloter </p>
                                                        <p> 10.Surat Keterangan Dari KBIH / BIRO pejalanan </p>
                                                    </> : null
                                            }

                                            {
                                                CurrentDataResponse.slug_kategori === "tugas-belajar" ?
                                                    <>
                                                        <h5>TUGAS BELAJAR (MANDIRI)</h5>
                                                        <p>1. SURAT PERMOHONAN TUGAS BELAJAR DARI YANG BERSANGKUTAN;</p>
                                                        <p>2. FOTOKOPI SK AWAL, SK PANGKAT TERAKHIR (Legalisir);</p>
                                                        <p>3. FOTOKOPI SKP 2 TAHUN TERAKHIR (Legalisir);</p>
                                                        <p>4. FOTOKOPI IJAZAH TERAKHIR (Legalisir);</p>
                                                        <p>5. FOTOKOPI CARPEG (Legalisir);</p>
                                                        <p>6. DAFTAR RIWAYAT HIDUP;</p>
                                                        <p>7. FOTOKOPI SURAT KEPUTUSAN AKREDITASI DARI BAN PT (MINIMAL AKREDITASI B);</p>
                                                        <p>8. SURAT PERNYATAAN BERMATERAI MENGIKUTI PENDIDIKAN DI LUAR JAM KERJA;</p>

                                                        <h5>TUGAS BELAJAR (BEASISWA)</h5>
                                                        <p>1. Surat Permohonan Tugas Belajar </p>
                                                        <p>2. Akreditasi Fakultas/Jurusan</p>
                                                        <p>3. Jadwal Kuliah</p>
                                                        <p>4. Surat Rekomendasi melanjutkan Pendidikan dari atasan Langsung  </p>
                                                        <p>5. Surat Rekomendasi melanjutkan Pendidikan dari Kepala Dinas Dikbud </p>
                                                        <p>6. Surat Pernyataan Tidak akan menuntut penyesuaian Ijazah  </p>
                                                        <p>7. Surat Pernyataan tidak pernah dijatuhi hukuman disiplin, Pidana atau Sedang Menjalani cuti diluar tanggungan Negara  </p>

                                                    </> : null
                                            }

                                            {
                                                CurrentDataResponse.slug_kategori === "usul-pensiun" ?
                                                    <>
                                                        <h5>USUL PENSIUN</h5>
                                                        <p>1. SURAT PERMOHONAN;</p>
                                                        <p>2. PAS POTO 4X6;</p>
                                                        <p>3. FOTOKOPI SK AWAL, SK 100%, SK PANGKAT TERAKHIR (Legalisir);</p>
                                                        <p>4. FOTOKOPI SKP 2 TAHUN TERAKHIR (Legalisir);</p>
                                                        <p>5. FOTOKOPI IJAZAH TERAKHIR (Legalisir);</p>
                                                        <p>6. FOTOKOPI KARPEG (Legalisir);</p>
                                                        <p>7. FOTOKOPI IJAZAH TERAKHIR (Legalisir);</p>
                                                        <p>8. FOTOKOPI SK GAJI BERKALA TERAKHIR (Legalisir);</p>
                                                    </> : null
                                            }

                                            {
                                                CurrentDataResponse.slug_kategori === "izin-operasional-sekolah" ?
                                                    <>
                                                        <h5>IZIN OPERASIONAL SEKOLAH</h5>
                                                        <p>1. Surat Permohonan</p>
                                                        <p>2. KTP Pemohon</p>
                                                        <p>3. Akta Notaris Pendirian Sekolah</p>
                                                        <p>4. Rekomendasi Kepala Kampung/Lurah</p>
                                                        <p>5. Rekomendasi Camat</p>
                                                        <p>6. Surat pernyataan dukungan dari lembaga sejenis </p>
                                                        <p>7. Berita Acara Rapat Pendirian Sekolah</p>
                                                        <p>8. Surat Keterangan Tanah/Sertifikat Tanah</p>
                                                        <p>9. Profil Sekolah</p>
                                                        <p>10. Struktur Organisasi Sekolah</p>
                                                        <p>11. Proses KBM minimal selama 2 tahun</p>
                                                        <p>12. Memiliki gedung dan ruang kelas</p>
                                                        <p>13. Luas lahan minimal
                                                            Taman Kanak Kanak : 2.500 m2
                                                            Sekolah Dasar : 5.000 m2
                                                            Sekolah Menengah Pertama : 10.000 m2</p>
                                                        <p>14. Jarak antar sekolah terdekat minimal 1 Km</p>
                                                        <p>15. NPWP Yayasan</p>
                                                        <p>16. NPWP Pemilik/Ketua Yayasan</p>
                                                        <p>17. No Handphone pemohon</p>
                                                        <p>18. Email dan password sekolah</p>
                                                        <p>19. Izin Mendirikan Bangunan</p>
                                                    </> : null
                                            }

                                            {
                                                CurrentDataResponse.slug_kategori === "izin-operasional-lembaga" ?
                                                    <>
                                                        <h5>IZIN OPERASIONAL LEMBAGA (PAUD / PKBM)</h5>
                                                        <p>1. Akte Notaris;</p>
                                                        <p>2. Ktp ketua pkbm;</p>
                                                        <p>3. Izin domisili dari desa/kelurahan;</p>
                                                        <p>4. Npwp Lembaga;</p>
                                                        <p>5. Rekening bank atas nama Lembaga;</p>
                                                        <p>6. Profil lembaga;</p>
                                                        <p>7. Susunan pengurus;</p>
                                                        <p>8. Sarana dan prasarana;</p>
                                                        <p>9. Pendidikan dan ketenagaan Pendidikan;</p>
                                                        <p>10. Rencana kegiatan pembelajaran;</p>
                                                        <p>11. Sarana kegiatan pembelajaran</p>
                                                    </> : null
                                            }

                                            {
                                                CurrentDataResponse.slug_kategori === "registrasi-sanggar-seni" ?
                                                    <>
                                                        <h5>REGISTRASI SANGGAR SENI</h5>
                                                        <p>1. Fotokopi KTP ketua sanggar;</p>
                                                        <p>2. Pas foto (4x6) berwarna ketua sanggar;</p>
                                                        <p>3. Rekomendasi camat;</p>
                                                        <p>4. Surat izin lingkungan dari kepala desa;</p>
                                                        <p>5. Struktur organisasi sanggar;</p>
                                                    </> : null
                                            }

                                            {/* <h5>A. Persyaratan Mengikuti Tes/Seleksi pada Perguruan Tinggi/Universitas</h5>
                            <p>1. Pengantar dari Kepala Perangkat Daerah </p>
                            <p>2. Permohonan dari yang bersangkutan </p>
                            <p>3. Foto Copy SK CPNS dan SK PNS yang telah (legalisir) </p>
                            <p>4. foto copy SK Pangkat terakhir yang telah di (legalisir) </p>
                            <p>5. Foto Copy Ijazah Terakhir dan transkip nilai (legalisir) </p>
                            <p>6. Fotokopi Jabatan terakhir (legalisir) </p>
                            <p>7. Fotokopi SKP 2 (dua) tahun terakhir (legalisir) </p>
                            <p>8. Surat Penawaran Pendidikan atau brosur dari perguruan tinggi jika pendidikan yang diikuti atas keinginan Ybs</p>
                            <p>9. Pernyataan bersedia menanggung semua biaya bagi Tugas Belajar Mandiri  </p> */}

                                        </div> : null
                                }


                                <p className='mb-0' style={{ marginTop: 40 }}>Kategori</p>
                                {
                                    CurrentDataResponse != null ?
                                        <div className='css-napawc_awno2a'>
                                            {
                                                RadioResponse && RadioResponse.map((item, index) => {
                                                    if (CurrentDataResponse.slug_kategori !== item.slug_kategori) {
                                                        return
                                                    }
                                                    return (
                                                        <div key={index}>
                                                            <input type='radio' name='sama' defaultChecked={CurrentDataResponse?.slug_kategori === item.slug_kategori ? true : false} value={item.id} /> {item.nama_kategori}
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div> : null
                                }

                                {
                                    CurrentDataResponse.slug_kategori == "izin-operasional-sekolah" ?
                                        <>
                                            <div className='mb-3'>
                                                <label>NIK</label>
                                                <input type="number" onChange={(e) => {
                                                    setPayload((prevObject) => ({ ...prevObject, ...{ nip_pegawai: e.target.value } }))
                                                }} value={Payload.nip_pegawai} className='form-control' />
                                            </div>
                                            <div className='mb-3'>
                                                <label>Nama</label>
                                                <input onChange={(e) => {
                                                    setPayload((prevObject) => ({ ...prevObject, ...{ nama_lengkap: e.target.value } }))
                                                }} value={Payload.nama_lengkap} className='form-control' />
                                                {/* <select onChange={(e) => handlePegawaiSelected(e)}>
                                        {
                                            PegawaiResponse.map((item, index) => {
                                                return (
                                                    <option value={item.id}>{item.nama_pegawai}</option>
                                                )
                                            })
                                        }
                                    </select> */}
                                            </div>
                                            <div className='mb-3'>
                                                <label>NPWP Yayasan</label>
                                                <input type="number" onChange={(e) => {
                                                    setPayload((prevObject) => ({ ...prevObject, ...{ npwp: e.target.value } }))
                                                }} value={Payload.npwp} className='form-control' />
                                            </div>
                                        </> :
                                        CurrentDataResponse.slug_kategori == "izin-operasional-lembaga" ?
                                            <>
                                                <div className='mb-3'>
                                                    <label>NIK</label>
                                                    <input type="number" onChange={(e) => {
                                                        setPayload((prevObject) => ({ ...prevObject, ...{ nip_pegawai: e.target.value } }))
                                                    }} value={Payload.nip_pegawai} className='form-control' />
                                                </div>
                                                <div className='mb-3'>
                                                    <label>Nama</label>
                                                    <input onChange={(e) => {
                                                        setPayload((prevObject) => ({ ...prevObject, ...{ nama_lengkap: e.target.value } }))
                                                    }} value={Payload.nama_lengkap} className='form-control' />
                                                    {/* <select onChange={(e) => handlePegawaiSelected(e)}>
                                        {
                                            PegawaiResponse.map((item, index) => {
                                                return (
                                                    <option value={item.id}>{item.nama_pegawai}</option>
                                                )
                                            })
                                        }
                                    </select> */}
                                                </div>
                                                <div className='mb-3'>
                                                    <label>NPWP Lembaga</label>
                                                    <input type="number" onChange={(e) => {
                                                        setPayload((prevObject) => ({ ...prevObject, ...{ npwp: e.target.value } }))
                                                    }} value={Payload.npwp} className='form-control' />
                                                </div>
                                            </> :
                                            CurrentDataResponse.slug_kategori == "registrasi-sanggar-seni" ?
                                                <>
                                                    <div className='mb-3'>
                                                        <label>NIK</label>
                                                        <input onChange={(e) => {
                                                            setPayload((prevObject) => ({ ...prevObject, ...{ nip_pegawai: e.target.value } }))
                                                        }} type="number" value={Payload.nip_pegawai} className='form-control' />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label>Nama</label>
                                                        <input onChange={(e) => {
                                                            setPayload((prevObject) => ({ ...prevObject, ...{ nama_lengkap: e.target.value } }))
                                                        }} value={Payload.nama_lengkap} className='form-control' />
                                                        {/* <select onChange={(e) => handlePegawaiSelected(e)}>
                                                    {
                                                        PegawaiResponse.map((item, index) => {
                                                            return (
                                                                <option value={item.id}>{item.nama_pegawai}</option>
                                                            )
                                                        })
                                                    }
                                                </select> */}
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    <div className='mb-3'>
                                                        <label>NIP</label>
                                                        {/* <input onChange={(e) => {
                                                            setPayload((prevObject) => ({ ...prevObject, ...{ nip_pegawai: e.target.value } }))
                                                        }} value={Payload.nip_pegawai} className='form-control' /> */}

                                                        <div className="input-group mb-3">
                                                            <input onChange={(e) => {
                                                                setPayload((prevObject) => ({ ...prevObject, ...{ nip_pegawai: e.target.value } }))
                                                            }} value={Payload.nip_pegawai} type="number" className="form-control" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                                                            <div className="input-group-append">
                                                                <button className="btn btn-outline-secondary" onClick={() => checkNip()} type="button">Check</button>
                                                            </div>
                                                        </div>

                                                        {/* <button type="button" onClick={() => checkNip()} className="mt-2" style={{ display: 'block' }}>Check NIP</button> */}
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label>Nama</label>
                                                        <input onChange={(e) => {
                                                            setPayload((prevObject) => ({ ...prevObject, ...{ nama_lengkap: e.target.value } }))
                                                        }} value={Payload.nama_lengkap} className='form-control' />
                                                        {/* <select onChange={(e) => handlePegawaiSelected(e)}>
                                                    {
                                                        PegawaiResponse.map((item, index) => {
                                                            return (
                                                                <option value={item.id}>{item.nama_pegawai}</option>
                                                            )
                                                        })
                                                    }
                                                </select> */}
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label>Pangkat / Gol</label>
                                                        <select value={Payload.pangkat_gol} onChange={(e) => {
                                                            setPayload((prevObject) => ({ ...prevObject, ...{ pangkat_gol: e.target.value } }))
                                                        }}>
                                                            <option>IA</option>
                                                            <option>IB</option>
                                                            <option>IC</option>
                                                            <option>ID</option>
                                                            <option>IIA</option>
                                                            <option>IIB</option>
                                                            <option>IIC</option>
                                                            <option>IID</option>
                                                            <option>IIIA</option>
                                                            <option>IIIB</option>
                                                            <option>IIIC</option>
                                                            <option>IIID</option>
                                                            <option>IVA</option>
                                                            <option>IVB</option>
                                                            <option>IVC</option>
                                                        </select>
                                                        {/* <input onChange={(e) => {
                                                            setPayload((prevObject) => ({ ...prevObject, ...{ pangkat_gol: e.target.value } }))
                                                        }} value={Payload.pangkat_gol} className='form-control' /> */}
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label>Unit Kerja</label>
                                                        <input onChange={(e) => {
                                                            setPayload((prevObject) => ({ ...prevObject, ...{ unit_kerja: e.target.value } }))
                                                        }} value={Payload.unit_kerja} className='form-control' />
                                                    </div>

                                                    {
                                                        CurrentDataResponse.slug_kategori === "usul-pensiun" || CurrentDataResponse.slug_kategori === "tugas-besar" ?
                                                            null : <>
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <div className='mb-3'>
                                                                            <label>Dari Tanggal</label>
                                                                            <input type="date" onChange={(e) => {
                                                                                setPayload((prevObject) => ({ ...prevObject, ...{ dari_tanggal: e.target.value } }))
                                                                            }} value={Payload.dari_tanggal} className='form-control' />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <div className='mb-3'>
                                                                            <label>Sampai Tanggal</label>
                                                                            <input type="date" onChange={(e) => {
                                                                                setPayload((prevObject) => ({ ...prevObject, ...{ sampai_tanggal: e.target.value } }))
                                                                            }} value={Payload.sampai_tanggal} className='form-control' />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                    }



                                                </>
                                }
                                <div className='mb-3'>
                                    <label>No Wa Aktif</label>
                                    <input type="number" onChange={(e) => {
                                        setPayload((prevObject) => ({ ...prevObject, ...{ no_wa_aktif: e.target.value } }))
                                    }} value={Payload.no_wa_aktif} className='form-control' />
                                </div>
                                <div className='mb-3'>
                                    <label>Upload Dokumen Persyaratan</label>
                                    <input onChange={handleFileChange} className='form-control' type='file' />
                                </div>
                                {
                                    CurrentDataResponse != null ?
                                        CanInput || (CurrentDataResponse.id == 3 || CurrentDataResponse.id == 7 || CurrentDataResponse.id == 8) ?
                                            <button type="button" onClick={() => createForm()}>Ajukan</button> : null : null
                                }
                            </form>
                        </div>
                    </div> : null
            }



        </Main>
    )
};
export default FormDetail;